import React, { useState, useEffect } from "react";
import api from "../../../config/axiosConfig";
import "./Experience.css";

import gateway from "../../../assets/experiance/gateway.jpeg";
import wellness from "../../../assets/experiance/wellness.jpeg";
import yoga from "../../../assets/experiance/yoga.jpeg";
import corporate from "../../../assets/experiance/corporate.jpeg";
import friends from "../../../assets/experiance/friends.jpeg";
import Enrichment from "../../../assets/experiance/school.jpeg";
import Sports from "../../../assets/experiance/sportretreate.jpeg";
import { Link } from "react-router-dom";
import { getTable } from "../../../config/seatable";

function Experience() {
  const [program, setProgram] = useState([]);

  // Local object for program images
  const programsImages = [
    { id: 1, name: "Getaway", programId: 1, image: gateway },
    { id: 2, name: "Wellness", programId: 2, image: wellness },
    { id: 3, name: "Yoga", programId: 3, image: yoga },
    { id: 4, name: "Corporate Offsite", programId: 4, image: corporate },
    { id: 6, name: "Friends & Family Retreat", programId: 6, image: friends },
    { id: 7, name: "Executive Enrichment", programId: 7, image: Enrichment },
    { id: 8, name: "Sports Retreat", programId: 8, image: Sports },
  ];

  useEffect(() => {
    const fetchProgram = async () => {
      try {
        const fetchedProgram = await getTable("Programs");
      //  console.log("programs are:", fetchedProgram);
       
        setProgram(fetchedProgram.rows); // Update state with fetched programs
        // console.log("fetchedProgram:", program);
        
      } catch (error) {
        console.error("Error fetching programs:", error);
      }
    };
    fetchProgram();
  }, []);



  return (
    <div className="py-5 exp-box px-xl-5 px-3">
      <h3 className="section-heading pb-4 text-start">Programs & Packages</h3>
      <div className="container-fluid programstable table-responsive">
        <table className="table-responsive mx-auto">
          <thead>
            {/* Row for Program Images */}
            <tr>
              {program.map((programItem) => {
               const matchedimage =  programsImages.find((item)=>(
                    (item.name === programItem["bTjl"]) ))
                return (
                  <th key={programItem.id} className="program-image-cell">
                    <Link to = "Allprograms">
                    <div
                      className="program-img-div"
                    >
                      <img
                        src={matchedimage.image}
                        alt={programItem["bTjl"]}
                        className="program-img object-fit-cover"
                        style={{aspectRatio:"3/3"}}
                      />
                    </div>
                    </Link>
                  </th>
                );
              })}
            </tr>

            {/* Row for Program Names */}
            <tr>
              {program.map((programItem) => (
                <th key={programItem.id} className="p-3">
                  {programItem["bTjl"]}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {/* Row for Program Descriptions */}
            <tr>
              {program.map((programItem) => (
                <td key={programItem.id} className="p-3">
                  {programItem["08nm"]}
                </td>
              ))}
            </tr>

            {/* Row for Minimum Days */}
            <tr>
              {program.map((programItem) => (
                <td key={programItem.id} className="p-3">
                  {programItem["GFj3"] || "N/A"} Days minimum
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Experience;
